import * as React from "react";
import ContentLoader from "react-content-loader";

export const Loader: React.FunctionComponent<{}> = () => {
    return (
        <ContentLoader
            height={100}
            width={640}
            speed={2}
            primaryColor="#f3f3f3"
            secondaryColor="#e2e1e3"
            style={{ width: "100%", height: "100%" }}
            className="loader"
        >
            <rect x="16" y="16" rx="5" ry="5" width="250" height="15" />
            <rect x="275" y="16" rx="5" ry="5" width="110" height="15" />
            <rect x="16" y="40" rx="5" ry="5" width="600" height="20" />
            <rect x="16" y="65" rx="5" ry="5" width="500" height="20" />
        </ContentLoader>
    );
};
